import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import PaginatedTable from '../Common/PaginatedTable';
import { Link } from 'react-router-dom';
import { HiEye, HiXCircle } from 'react-icons/hi';
import { Manufacturer } from '../../Models/Manufacturer';
import { Tooltip } from 'flowbite-react';
export default function ManufacturerListTable({
  data,
}: {
  data: Manufacturer[];
}) {
  const columnHelper = createColumnHelper<Manufacturer>();

  const columns = [
    columnHelper.accessor((row) => row.id, {
      id: 'id',
      header: '',
      cell: (info) => (
        <div className='flex justify-center gap-1'>
          <Link
            to={`/manufacturer/${info.getValue()}`}
            className='buttonMain p-2'
          >
            <Tooltip content='View Manufacturer'>
              <HiEye />
            </Tooltip>
          </Link>
        </div>
      ),
      footer: (info) => info.column.id,
      size: 25,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.name, {
      id: 'name',
      header: 'Name',
      // cell: (info) => <i>{info.getValue()}</i>,
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      filterFn: 'includesString',
    }),
    columnHelper.accessor((row) => row.primaryImageURL, {
      header: 'Image',
      cell: (info) => (
        <img src={info.getValue()} alt='Profile' style={{ width: '150px' }} />
      ),
    }),
    columnHelper.accessor((row) => row.rimssOemvendorNumber, {
      id: 'rimssOemvendorNumber',
      header: 'Vendor Number',
      // cell: (info) => <i>{info.getValue()}</i>,
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      filterFn: 'includesString',
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
      sorting: [
        {
          id: 'name',
          desc: false,
        },
      ],
    },
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });

  return (
    <>
      <div className='w-full mx-auto overflow-x-auto'>
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode='onChange'
          showFilters={true}
        />
      </div>
    </>
  );
}
